module.exports = __webpack_public_path__ + "media/images/website-03cf8a458027bbd07b6a2837095218d6.svg";